module.exports = {
  DEFAULT: {
    0:                [ 0x0e, 0x1b, 0x1b, 0x1b, 0x1b, 0x1b, 0x0e, 0x00 ],
    1:                [ 0x02, 0x06, 0x0e, 0x06, 0x06, 0x06, 0x06, 0x00 ],
    2:                [ 0x0e, 0x1b, 0x03, 0x06, 0x0c, 0x18, 0x1f, 0x00 ],
    3:                [ 0x0e, 0x1b, 0x03, 0x0e, 0x03, 0x1b, 0x0e, 0x00 ],
    4:                [ 0x03, 0x07, 0x0f, 0x1b, 0x1f, 0x03, 0x03, 0x00 ],
    5:                [ 0x1f, 0x18, 0x1e, 0x03, 0x03, 0x1b, 0x0e, 0x00 ],
    6:                [ 0x0e, 0x1b, 0x18, 0x1e, 0x1b, 0x1b, 0x0e, 0x00 ],
    7:                [ 0x1f, 0x03, 0x06, 0x0c, 0x0c, 0x0c, 0x0c, 0x00 ],
    8:                [ 0x0e, 0x1b, 0x1b, 0x0e, 0x1b, 0x1b, 0x0e, 0x00 ],
    9:                [ 0x0e, 0x1b, 0x1b, 0x0f, 0x03, 0x1b, 0x0e, 0x00 ],
    10:               [ 0x17, 0x15, 0x15, 0x15, 0x17, 0x00, 0x1f, 0x00 ],
    11:               [ 0x0a, 0x0a, 0x0a, 0x0a, 0x0a, 0x00, 0x1f, 0x00 ],
    12:               [ 0x17, 0x11, 0x17, 0x14, 0x17, 0x00, 0x1f, 0x00 ],
    13:               [ 0x17, 0x11, 0x13, 0x11, 0x17, 0x00, 0x1f, 0x00 ],
    14:               [ 0x15, 0x15, 0x17, 0x11, 0x11, 0x00, 0x1f, 0x00 ],
    15:               [ 0x17, 0x14, 0x17, 0x11, 0x17, 0x00, 0x1f, 0x00 ],
    16:               [ 0x17, 0x14, 0x17, 0x15, 0x17, 0x00, 0x1f, 0x00 ],
    17:               [ 0x17, 0x11, 0x12, 0x12, 0x12, 0x00, 0x1f, 0x00 ],
    18:               [ 0x17, 0x15, 0x17, 0x15, 0x17, 0x00, 0x1f, 0x00 ],
    19:               [ 0x17, 0x15, 0x17, 0x11, 0x17, 0x00, 0x1f, 0x00 ],
    circle:           [ 0x00, 0x0e, 0x11, 0x11, 0x11, 0x0e, 0x00, 0x00 ],
    cdot:             [ 0x00, 0x0e, 0x11, 0x15, 0x11, 0x0e, 0x00, 0x00 ],
    donut:            [ 0x00, 0x0e, 0x1f, 0x1b, 0x1f, 0x0e, 0x00, 0x00 ],
    ball:             [ 0x00, 0x0e, 0x1f, 0x1f, 0x1f, 0x0e, 0x00, 0x00 ],
    square:           [ 0x00, 0x1f, 0x11, 0x11, 0x11, 0x1f, 0x00, 0x00 ],
    sdot:             [ 0x00, 0x1f, 0x11, 0x15, 0x11, 0x1f, 0x00, 0x00 ],
    fbox:             [ 0x00, 0x1f, 0x1f, 0x1f, 0x1f, 0x1f, 0x00, 0x00 ],
    sbox:             [ 0x00, 0x00, 0x0e, 0x0a, 0x0e, 0x00, 0x00, 0x00 ],
    sfbox:            [ 0x00, 0x00, 0x0e, 0x0e, 0x0e, 0x00, 0x00, 0x00 ],
    bigpointerright:  [ 0x08, 0x0c, 0x0a, 0x09, 0x0a, 0x0c, 0x08, 0x00 ],
    bigpointerleft:   [ 0x02, 0x06, 0x0a, 0x12, 0x0a, 0x06, 0x02, 0x00 ],
    arrowright:       [ 0x08, 0x0c, 0x0a, 0x09, 0x0a, 0x0c, 0x08, 0x00 ],
    arrowleft:        [ 0x02, 0x06, 0x0a, 0x12, 0x0a, 0x06, 0x02, 0x00 ],
    ascprogress1:     [ 0x10, 0x10, 0x10, 0x10, 0x10, 0x10, 0x10, 0x10 ],
    ascprogress2:     [ 0x18, 0x18, 0x18, 0x18, 0x18, 0x18, 0x18, 0x18 ],
    ascprogress3:     [ 0x1c, 0x1c, 0x1c, 0x1c, 0x1c, 0x1c, 0x1c, 0x1c ],
    ascprogress4:     [ 0x1e, 0x1e, 0x1e, 0x1e, 0x1e, 0x1e, 0x1e, 0x1e ],
    fullprogress:     [ 0x1f, 0x1f, 0x1f, 0x1f, 0x1f, 0x1f, 0x1f, 0x1f ],
    descprogress1:    [ 0x01, 0x01, 0x01, 0x01, 0x01, 0x01, 0x01, 0x01 ],
    descprogress2:    [ 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03, 0x03 ],
    descprogress3:    [ 0x07, 0x07, 0x07, 0x07, 0x07, 0x07, 0x07, 0x07 ],
    descprogress4:    [ 0x0f, 0x0f, 0x0f, 0x0f, 0x0f, 0x0f, 0x0f, 0x0f ],
    ascchart1:        [ 0x1f, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00 ],
    ascchart2:        [ 0x1f, 0x1f, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00 ],
    ascchart3:        [ 0x1f, 0x1f, 0x1f, 0x00, 0x00, 0x00, 0x00, 0x00 ],
    ascchart4:        [ 0x1f, 0x1f, 0x1f, 0x1f, 0x00, 0x00, 0x00, 0x00 ],
    ascchart5:        [ 0x1f, 0x1f, 0x1f, 0x1f, 0x1f, 0x00, 0x00, 0x00 ],
    ascchart6:        [ 0x1f, 0x1f, 0x1f, 0x1f, 0x1f, 0x1f, 0x00, 0x00 ],
    ascchart7:        [ 0x1f, 0x1f, 0x1f, 0x1f, 0x1f, 0x1f, 0x1f, 0x00 ],
    descchart1:       [ 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x1f ],
    descchart2:       [ 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x1f, 0x1f ],
    descchart3:       [ 0x00, 0x00, 0x00, 0x00, 0x00, 0x1f, 0x1f, 0x1f ],
    descchart4:       [ 0x00, 0x00, 0x00, 0x00, 0x1f, 0x1f, 0x1f, 0x1f ],
    descchart5:       [ 0x00, 0x00, 0x00, 0x1f, 0x1f, 0x1f, 0x1f, 0x1f ],
    descchart6:       [ 0x00, 0x00, 0x1f, 0x1f, 0x1f, 0x1f, 0x1f, 0x1f ],
    descchart7:       [ 0x00, 0x1f, 0x1f, 0x1f, 0x1f, 0x1f, 0x1f, 0x1f ],
    borderleft1:      [ 0x01, 0x01, 0x01, 0x01, 0x01, 0x01, 0x01, 0x01 ],
    borderleft2:      [ 0x03, 0x02, 0x02, 0x02, 0x02, 0x02, 0x02, 0x03 ],
    borderleft3:      [ 0x07, 0x04, 0x04, 0x04, 0x04, 0x04, 0x04, 0x07 ],
    borderleft4:      [ 0x0f, 0x08, 0x08, 0x08, 0x08, 0x08, 0x08, 0x0f ],
    borderleft5:      [ 0x1f, 0x10, 0x10, 0x10, 0x10, 0x10, 0x10, 0x1f ],
    bordertopbottom5: [ 0x1f, 0x00, 0x00, 0x00, 0x00, 0x00, 0x00, 0x1f ],
    borderright1:     [ 0x10, 0x10, 0x10, 0x10, 0x10, 0x10, 0x10, 0x10 ],
    borderright2:     [ 0x18, 0x08, 0x08, 0x08, 0x08, 0x08, 0x08, 0x18 ],
    borderright3:     [ 0x1c, 0x04, 0x04, 0x04, 0x04, 0x04, 0x04, 0x1c ],
    borderright4:     [ 0x1e, 0x02, 0x02, 0x02, 0x02, 0x02, 0x02, 0x1e ],
    borderright5:     [ 0x1f, 0x01, 0x01, 0x01, 0x01, 0x01, 0x01, 0x1f ],
    box1:             [ 0x03, 0x03, 0x03, 0x00, 0x00, 0x00, 0x00, 0x00 ],
    box2:             [ 0x18, 0x18, 0x18, 0x00, 0x00, 0x00, 0x00, 0x00 ],
    box3:             [ 0x1b, 0x1b, 0x1b, 0x00, 0x00, 0x00, 0x00, 0x00 ],
    box4:             [ 0x00, 0x00, 0x00, 0x00, 0x03, 0x03, 0x03, 0x00 ],
    box5:             [ 0x03, 0x03, 0x03, 0x00, 0x03, 0x03, 0x03, 0x00 ],
    box6:             [ 0x18, 0x18, 0x18, 0x00, 0x03, 0x03, 0x03, 0x00 ],
    box7:             [ 0x1b, 0x1b, 0x1b, 0x00, 0x03, 0x03, 0x03, 0x00 ],
    box8:             [ 0x00, 0x00, 0x00, 0x00, 0x18, 0x18, 0x18, 0x00 ],
    box9:             [ 0x03, 0x03, 0x03, 0x00, 0x18, 0x18, 0x18, 0x00 ],
    box10:            [ 0x18, 0x18, 0x18, 0x00, 0x18, 0x18, 0x18, 0x00 ],
    box11:            [ 0x1b, 0x1b, 0x1b, 0x00, 0x18, 0x18, 0x18, 0x00 ],
    box12:            [ 0x00, 0x00, 0x00, 0x00, 0x1b, 0x1b, 0x1b, 0x00 ],
    box13:            [ 0x03, 0x03, 0x03, 0x00, 0x1b, 0x1b, 0x1b, 0x00 ],
    box14:            [ 0x18, 0x18, 0x18, 0x00, 0x1b, 0x1b, 0x1b, 0x00 ],
    box15:            [ 0x1b, 0x1b, 0x1b, 0x00, 0x1b, 0x1b, 0x1b, 0x00 ],
    euro:             [ 0x03, 0x04, 0x1e, 0x08, 0x1e, 0x08, 0x07, 0x00 ],
    cent:             [ 0x00, 0x00, 0x0e, 0x11, 0x10, 0x15, 0x0e, 0x08 ],
    speaker:          [ 0x01, 0x03, 0x0f, 0x0f, 0x0f, 0x03, 0x01, 0x00 ],
    sound:            [ 0x08, 0x10, 0x00, 0x18, 0x00, 0x10, 0x08, 0x00 ],
    x:                [ 0x00, 0x1b, 0x0e, 0x04, 0x0e, 0x1b, 0x00, 0x00 ],
    target:           [ 0x00, 0x0a, 0x11, 0x15, 0x11, 0x0a, 0x00, 0x00 ],
    pointerright:     [ 0x00, 0x08, 0x0c, 0x0e, 0x0c, 0x08, 0x00, 0x00 ],
    pointerup:        [ 0x00, 0x00, 0x04, 0x0e, 0x1f, 0x00, 0x00, 0x00 ],
    pointerleft:      [ 0x00, 0x02, 0x06, 0x0e, 0x06, 0x02, 0x00, 0x00 ],
    pointerdown:      [ 0x00, 0x00, 0x1f, 0x0e, 0x04, 0x00, 0x00, 0x00 ],
    arrowne:          [ 0x00, 0x0f, 0x03, 0x05, 0x09, 0x10, 0x00, 0x00 ],
    arrownw:          [ 0x00, 0x1e, 0x18, 0x14, 0x12, 0x01, 0x00, 0x00 ],
    arrowsw:          [ 0x00, 0x01, 0x12, 0x14, 0x18, 0x1e, 0x00, 0x00 ],
    arrowse:          [ 0x00, 0x10, 0x09, 0x05, 0x03, 0x0f, 0x00, 0x00 ],
    dice1:            [ 0x00, 0x00, 0x00, 0x04, 0x00, 0x00, 0x00, 0x00 ],
    dice2:            [ 0x00, 0x10, 0x00, 0x00, 0x00, 0x01, 0x00, 0x00 ],
    dice3:            [ 0x00, 0x10, 0x00, 0x04, 0x00, 0x01, 0x00, 0x00 ],
    dice4:            [ 0x00, 0x11, 0x00, 0x00, 0x00, 0x11, 0x00, 0x00 ],
    dice5:            [ 0x00, 0x11, 0x00, 0x04, 0x00, 0x11, 0x00, 0x00 ],
    dice6:            [ 0x00, 0x11, 0x00, 0x11, 0x00, 0x11, 0x00, 0x00 ],
    bell:             [ 0x04, 0x0e, 0x0e, 0x0e, 0x1f, 0x00, 0x04, 0x00 ],
    smile:            [ 0x00, 0x0a, 0x00, 0x11, 0x0e, 0x00, 0x00, 0x00 ],
    note:             [ 0x02, 0x03, 0x02, 0x0e, 0x1e, 0x0c, 0x00, 0x00 ],
    clock:            [ 0x00, 0x0e, 0x15, 0x17, 0x11, 0x0e, 0x00, 0x00 ],
    heart:            [ 0x00, 0x0a, 0x1f, 0x1f, 0x1f, 0x0e, 0x04, 0x00 ],
    duck:             [ 0x00, 0x0c, 0x1d, 0x0f, 0x0f, 0x06, 0x00, 0x00 ],
    check:            [ 0x00, 0x01, 0x03, 0x16, 0x1c, 0x08, 0x00, 0x00 ],
    retarrow:         [ 0x01, 0x01, 0x05, 0x09, 0x1f, 0x08, 0x04, 0x00 ],
    runninga:         [ 0x06, 0x06, 0x05, 0x0e, 0x14, 0x04, 0x0a, 0x11 ],
    runningb:         [ 0x06, 0x06, 0x04, 0x0e, 0x0e, 0x04, 0x0a, 0x0a ],
  }
};
